import { render, staticRenderFns } from "./BeginnersGuide.vue?vue&type=template&id=b22ad65c"
import script from "./BeginnersGuide.vue?vue&type=script&lang=js"
export * from "./BeginnersGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports